import { applyBrandKit } from '@/lib/layouts/applyBrandKit';
import {
  resolveFillerPlaylist,
  stripDeferredRandomFillers,
} from '@/lib/layouts/fillerPlaylist';
import { parsePersistedPostLayout } from '@/lib/layouts/persistPostLayout';
import type { PostLayoutConfig } from '@/lib/layouts/types';
import {
  harvestBrandKitLayoutSource,
  type HarvestableKitData,
} from './harvestBrandKitLayoutSource';

function overlayMatchingFillerSettings(
  current: PostLayoutConfig,
  kitData: HarvestableKitData | null | undefined,
): PostLayoutConfig {
  if (current.kind !== 'satisfatorio' && current.kind !== 'fofoca') return current;
  const parsed = parsePersistedPostLayout(kitData?.post_layout);
  if (!parsed || parsed.postLayout.kind !== current.kind) return current;
  const kitLayout = stripDeferredRandomFillers(parsed.postLayout);
  if (!('fillerUrl' in kitLayout)) return current;

  if (kitLayout.fillerRandomize) {
    return {
      ...current,
      fillerSpeed: kitLayout.fillerSpeed ?? current.fillerSpeed,
      fillerRandomize: true,
      fillerUrl: '',
      fillerUrls: [],
    };
  }

  const kitUrls = resolveFillerPlaylist(kitLayout);
  if (kitUrls.length > 0) {
    return {
      ...current,
      fillerSpeed: kitLayout.fillerSpeed ?? current.fillerSpeed,
      fillerRandomize: false,
      fillerUrl: kitUrls[0] ?? '',
      fillerUrls: kitUrls,
    };
  }

  if (kitLayout.fillerSpeed != null) {
    return { ...current, fillerSpeed: kitLayout.fillerSpeed };
  }
  return current;
}

export function overlayTemplateOnCurrentLayout(
  current: PostLayoutConfig | null,
  kitData: HarvestableKitData | null | undefined,
): PostLayoutConfig | null {
  if (!current) return null;
  return overlayMatchingFillerSettings(
    applyBrandKit(current, harvestBrandKitLayoutSource(kitData)),
    kitData,
  );
}
